module.exports = __webpack_public_path__ + "img/collect_pic_14.97faa190.png";